// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SocialEntitiesView_Wrapper__2SWT1","Image":"SocialEntitiesView_Image__1Pmef","Text":"SocialEntitiesView_Text__1Tydz"};